import raw from "./raw/icon-declined-24x24.svg";
import { IconBuilder } from "./builder/IconBuilder";

export const Declined = IconBuilder({
    svg: raw,
    defaultColor: theme => theme.danger1
});
